import {MantineTransition} from '@mantine/core';

const commonStylesLabel = {
    position: 'absolute' as const,
    transitionProperty: 'width',
    duration: 1000,
    timingFunction: 'ease',
    alignItems: 'center',
};

export const growRight: MantineTransition = {
    in: {
        width: '8em',
        left: '1em',
        justifyContent: 'flex-end',
        paddingRight: '1em',
    },
    out: {
        width: '0px',
        left: '1em',
    },
    transitionProperty: 'width;',
    common: commonStylesLabel,
};

export const growLeft: MantineTransition = {
    in: {
        width: '9em',
        right: '1em',
        justifyContent: 'flex-start',
        paddingLeft: '1em',
    },
    out: {
        width: '0px',
        right: '1em',
    },
    transitionProperty: 'width;',
    common: commonStylesLabel,
};


const commonStylesFlipper: React.CSSProperties = {
    backfaceVisibility: 'hidden',
    position: 'absolute' as const, // This must be absolute for the transition to be smooth
    top: '9%',
    right: '0%',
    left: '6%',
    width: '87.5%',
    height: '93%',
    transformStyle: 'preserve-3d',
    transition: 'transform 0.6s ease',
};

export const rotateLeft: MantineTransition = {
    in: {transform: 'rotateY(0deg)'},
    out: {transform: 'rotateY(-180deg)'},
    common: commonStylesFlipper,
    transitionProperty: 'transform',
};

export const rotateRight: MantineTransition = {
    in: {transform: 'rotateY(0deg)'},
    out: {transform: 'rotateY(180deg)'},
    common: commonStylesFlipper,
    transitionProperty: 'transform',
};